import React, { Component } from "react";
import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addServiceProvider } from "../../../../store/service-provider/actions";
import ServiceProviderInformationForm from "./components/ServiceProviderInformationForm";
import ModifiedMetaTags from "../../../../components/ModifiedMetaTags";

class AddServiceProvider extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Add service provider | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Service Providers"
              breadcrumbItem="Add service provider"
              link="/service-providers"
            />
            <ServiceProviderInformationForm
              contactData={this.props.contactData}
              history={this.props.history}
              addServiceProvider={this.props.addServiceProvider}
              loader={false}
              permissions={this.props.permissions}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddServiceProvider.propTypes = {
  contactData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  addServiceProvider: PropTypes.func.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  contactData: state.ServiceProviders.data,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  addServiceProvider,
})(AddServiceProvider);
